const getCookie = (cname) => {
  const cookiesArray = document.cookie.split(';').map((cookie) => {
    const [name, ...rest] = cookie.trim().split('=');
    return [name, rest.join('=')];
  });

  const cookie = cookiesArray.find(([name]) => name === cname);

  if (cookie) {
    return cookie[1];
  }

  return false;
};

export default getCookie;
